import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { withDefaults } from 'vue';
import { AtomButton, PlusIcon, TickCircleIcon } from '@/components/atoms';
interface IProps {
  btnClearTitle: string;
  btnSendTitle: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeButtonsSettings',
  props: {
    btnClearTitle: { default: 'Limpar' },
    btnSendTitle: { default: 'Cadastrar' }
  },
  emits: ['handleCancel', 'handleSubmit'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_col, {
    cols: "12",
    md: "5",
    lg: "3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "w-100 py-0",
        "align-content": "space-between",
        dense: true,
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AtomButton), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handleCancel'))),
                classes: "btn-cancel w-100",
                text: props.btnClearTitle
              }, null, 8, ["text"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pl-2 pr-0 mr-0"
          }, {
            default: _withCtx(() => [
              (props.btnSendTitle === 'Cadastrar')
                ? (_openBlock(), _createBlock(_unref(AtomButton), {
                    key: 0,
                    "prepend-icon": true,
                    classes: "btn-confirm w-100",
                    text: props.btnSendTitle,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('handleSubmit')))
                  }, {
                    prependIcon: _withCtx(() => [
                      _createVNode(_unref(PlusIcon))
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : _createCommentVNode("", true),
              (props.btnSendTitle === 'Concluir')
                ? (_openBlock(), _createBlock(_unref(AtomButton), {
                    key: 1,
                    "prepend-icon": true,
                    classes: "btn-confirm w-100",
                    text: props.btnSendTitle,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('handleSubmit')))
                  }, {
                    prependIcon: _withCtx(() => [
                      _createVNode(_unref(TickCircleIcon))
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : _createCommentVNode("", true),
              (props.btnSendTitle === 'Buscar')
                ? (_openBlock(), _createBlock(_unref(AtomButton), {
                    key: 2,
                    "prepend-icon": true,
                    classes: "btn-confirm w-100",
                    text: props.btnSendTitle,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('handleSubmit')))
                  }, {
                    prependIcon: _withCtx(() => [
                      _createVNode(_unref(TickCircleIcon))
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})